export const VIEW_ALL_PRODUCTS = 'header_navigation.view_all_products';
export const BANNER_ALT = 'header_navigation.banner_alt';
